"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datePart_1 = require("./datePart");
/**
 * Zwraca tablicę zawierającą listę lat pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 */
function listYears(startDate, endDate) {
    var y1 = datePart_1.default(startDate, 'y');
    var y2 = datePart_1.default(endDate, 'y');
    var result = [];
    if (y1 && y2) { //datePart przy nieprawidłowej dacie zwraca 0
        while (y1 <= y2) {
            result.push(y1);
            y1++;
        }
    }
    return result;
}
exports.default = listYears;
//# sourceMappingURL=listYears.js.map